import { Injectable, Inject } from '@angular/core';
import { BaseSearchDO } from './BaseSearch.model';

export class SearchResultDO extends BaseSearchDO {


	public baseAgentId: String = null;
	public statusCd: String = null;
	public stageCd: String = null;
	public leadRefNum: String = null;
	public quotationRefNum: String = null;
	public productCd: String = null;
	public productTypeCd: String = null;
	public planOptionCd: String = null;
	public clientNum: String = null;
	public clientFirstName: String = null;
	public clientMiddleName: String = null;
	public clientLastName: String = null;
	public vehicleVariant: String = null;
	public engineNum: String = null;
	public chasisNum: String = null;
	public travelFromCountryCd: String = null;
	public travelToCountryCd: String = null;
	public travelFromCityCd: String = null;
	public travelToCityCd: String = null;
	public quotationContainerNum: String = null;



}